<template>
<div style="padding: 15px">
    <div class="row" v-if="customer_documents.length > 0"><h3>Dokumenty</h3>
        <template >
            <div class="col s2 leftlabel">{{$t('documents.date_of_issue')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.description')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.document_type')}}</div>
        </template>
    </div>
    <template  v-for="(docs, index) in customer_documents">
        <h4 v-if="index != 'undefined'">{{place_names[index].name}}</h4>
        <br/>
        <div class="row" v-for="doc in docs">
            <div class="col s2 input-field">
                <input type="date" class="datepicker" v-model="doc.date" :disabled="true">
            </div>
            <div class="col s3 input-field">
                <input v-model="doc.description" :disabled="editdocuments == false" />
            </div>
            <div class="col s3 input-field">
                <select v-model="doc.type" :disabled="true">
                    <option value="pzs">{{$t('documents.types.pzs')}}</option>
                    <option value="agreement">{{$t('documents.types.agreement')}}</option>
                    <option value="agreement_annex">{{$t('documents.types.agreement_annex')}}</option>
                    <option value="plan">{{$t('documents.types.plan')}}</option>
                    <option value="instruction">{{$t('documents.types.instruction')}}</option>
                    <option value="other">{{$t('documents.types.other')}}</option>
                </select>
            </div>
            <div class="col s1" :class="{'docselector': (doc.file == undefined && doc.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                <a :href="doc.url" v-if="doc.url">
                    <i class="material-icons">insert_drive_file</i>
                </a>
            </div>
        </div>
    </template>
      <div v-if="load">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    <h3  v-if="substance_documents.length > 0">Karty charakterystyki, etykiety i pozwolenia produktów biobójczych</h3>
    <template  v-for="(docs, index) in substance_documents">
        <h3>{{substance_names[index].name}}</h3>
    <div class="row">
        <template v-if="docs.length > 0">
            <div class="col s2 leftlabel">{{$t('documents.date_of_issue')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.description')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.document_type')}}</div>
        </template>
    </div>
    <div class="row" v-for="(doc, index) in docs" v-show="!doc._destroy">
         <div class="col s2 input-field">
            <input type="date" class="datepicker" v-model="doc.date" :disabled="true">
        </div>
        <div class="col s3 input-field">
            <input v-model="doc.description" :disabled="editdocuments == false" />
        </div>
        <div class="col s3 input-field">
            <select v-model="doc.type" :disabled="true">
                <option value="characteristic">{{$t('substances.documents.characteristic')}}</option>
                <option value="etiquete">{{$t('substances.documents.etiquete')}}</option>
                <option value="permission">{{$t('substances.documents.permission')}}</option>
                <option value="other">{{$t('substances.documents.other')}}</option>
            </select>
        </div>
        <div class="col s1" :class="{'docselector': (doc.file == undefined && doc.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <label :for="'docs'+index" v-if="!doc.url">{{doc.file == undefined ? "Wybierz plik..." : doc.file.name}}</label>
            <input type="file" :id="'docs'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.url" hidden />
            <a :href="doc.url" v-if="doc.url">
                <i class="material-icons">insert_drive_file</i>
            </a>
        </div>
    </div>
    </template>
      <div v-if="load">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    <h3>Dokumenty firmy DDD</h3>
    <div class="row" style="padding-bottom: 25px;">
        <template v-if="items.length > 0">
            <div class="col s2 leftlabel">{{$t('documents.date_of_issue')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.name')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.description')}}</div>
            <div class="col s2 leftlabel">{{$t('documents.document_type')}}</div>
        </template>
    </div>
    <div class="row" v-for="(doc, index) in items" v-show="!doc._destroy" v-if="doc.url">
         <div class="col s2 input-field">
            <input type="date" class="datepicker" v-model="doc.created_at" :disabled="true">
        </div>
        <div class="col s3 input-field">
            <input v-model="doc.name" :disabled="editdocuments == false" :placeholder="$t('settings.documents.name_placeholder')" />
        </div>
        <div class="col s3  input-field">
            <input v-model="doc.description" :disabled="editdocuments == false" :placeholder="$t('settings.documents.description_placeholder')" />
        </div>
        <div class="col s2 selectorignored">
            <select v-model="doc.type" :disabled="editdocuments == false || doc.id">
                <option value="insurance">{{$t('settings.documents.types.insurance')}}</option>
                <option value="certificate">{{$t('settings.documents.types.certificate')}}</option>
                <option value="reference">{{$t('settings.documents.types.references')}}</option>
                <option value="other_document">{{$t('settings.documents.types.other')}}</option>
            </select>
        </div>
        <div class="col s1" :class="{'docselector': (doc.file == undefined && doc.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <label :for="'docs'+index" v-if="!doc.url">{{doc.file == undefined ? "Wybierz plik..." : doc.file.name}}</label>
            <input type="file" :id="'docs'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.url" hidden />
            <a :href="doc.url" v-if="doc.url">
                <i class="material-icons">insert_drive_file</i>
            </a>
        </div>
       </div>
       <div v-if="load">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
export default {
  data: function () {
    return {
      items: [],
      customer_documents: [],
      substance_documents: [],
      editdocuments: false,
      place_names: {},
      substance_names: {},
      load: true
    }
  },
  mounted: async function(){
    var response = await axios.get("/documents.json");
    var docs = []
    for (var insurance of response.data.insurances) {
        docs.push({
            id: insurance.id,
            type: "insurance",
            created_at: moment(insurance.created_at).format(moment.HTML5_FMT.DATE),
            name: insurance.policy_no,
            url: insurance.url,
            description: (_.isNil(insurance.description) && moment(insurance.valid_until).isValid() ? moment(insurance.valid_until).format("DD.MM.YYYY") : insurance.description),
            date: insurance.valid_until
        })
    }
    for (var reference of response.data.references) {
        docs.push({
            id: reference.id,
            created_at: moment(reference.created_at).format(moment.HTML5_FMT.DATE),
            type: "reference",
            url: reference.url,
            date: reference.date,
            description: reference.description,
            name: reference.name
        })
    }
    for (var certificate of response.data.certificates) {
        docs.push({
            id: certificate.id,
            type: "certificate",
            created_at: moment(certificate.created_at).format(moment.HTML5_FMT.DATE),
            url: certificate.url,
            date: certificate.date,
            description: (_.isNil(certificate.description) && moment(certificate.date).isValid() ? moment(certificate.date).format("DD.MM.YYYY") : certificate.description),
            name: certificate.name
        })
    }
    if(response.data.other_documents != null){
        for (var other_document of response.data.other_documents) {
            docs.push({
                id: other_document.id,
                type: "other_document",
                url: other_document.url,
                created_at: moment(other_document.created_at).format(moment.HTML5_FMT.DATE),
                date: other_document.date,
                description: (_.isNil(other_document.description) && moment(other_document.date).isValid() ? moment(other_document.date).format("DD.MM.YYYY") : other_document.description),
                name: other_document.name
            })
        }
    }
    
   this.items = docs;
    if(response.data.documents != null){
        var customer_documents = []
        for (var customer_document of response.data.documents) {
              customer_documents.push({
                  id: customer_document.id,
                  place_id: customer_document.place != null ? customer_document.place.id : 0,
                  type: customer_document.doctype,
                  url: customer_document.attachment,
                  created_at: moment(customer_document.created_at).format(moment.HTML5_FMT.DATE),
                  date: customer_document.date,
                  description: (_.isNil(customer_document.description) && moment(customer_document.date).isValid() ? moment(customer_document.date).format("DD.MM.YYYY") : customer_document.description),
                  name: customer_document.name
              })
              this.place_names[customer_document.place != null ? customer_document.place.id : 0] = customer_document.place;
        }
        this.place_names[0] = {name: "-"}
        this.customer_documents = _.groupBy(_.orderBy(customer_documents, ['type', 'date']), function(c){ 
            c.place != null ? c.place.id : 0
        });
    }

    if(response.data.substances_documents != null){
        var substance_documents = []
        for (var substance_document of response.data.substances_documents) {
              substance_documents.push({
                  id: substance_document.id,
                  type: substance_document.doctype,
                  url: substance_document.attachment.url,
                  created_at: moment(substance_document.created_at).format(moment.HTML5_FMT.DATE),
                  date: moment(substance_document.created_at).format("YYYY-MM-DD"),
                  description: (_.isNil(substance_document.description) && moment(substance_document.created_at).isValid() ? moment(substance_document.created_at).format("DD.MM.YYYY") : substance_document.description),
                  name: substance_document.name,
                  substance_id: substance_document.substance.id
              })
              this.substance_names[substance_document.substance.id] = substance_document.substance;
        }
        this.substance_documents = _.groupBy(_.orderBy(substance_documents, ['type', 'date']), function(c){ return c.substance_id });
    }
    this.load = false;
  },
methods: {

},
  computed: {
   
  },
  
}
</script>
<style scoped>
.row {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
select{
  display: block !important;
}
/deep/ select:disabled {
    color: black;
}
</style>